import React from 'react';

import { observer } from 'mobx-react';
import { Surface } from '@infoods/lifebase-ui';

import classes from './ScanningPeakHoursWidget.module.scss';
import { WidgetTitle } from '../WidgetTitle/WidgetTitle';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';
import { useScanningPeakMatrix } from './hooks/useScanningPeakMatrix';
import { HeatmapLegend } from './HeatmapLegend/HeatmapLegend';
import { HeatmapTitleRow } from './HeatmapTitleRow/HeatmapTitleRow';
import { HeatmapDayRow } from './HeatmapDayRow/HeatmapDayRow';
import { daysOfWeek } from '../../../../shared/constants/daysOfWeek';
import { LbHorizontalScrollContainer } from '../../../../shared/components/LbHorizontalScrollContainer/LbHorizontalScrollContainer';

const ScanningPeakHoursWidget = observer(() => {
  const { dateRangePreset, solutionTypeFilter } = entityDashboardFilterStore;
  const { matrix } = useScanningPeakMatrix({ dateRangePreset, solutionTypeFilter });

  return (
    <Surface radius="l">
      <div className={classes.title}>
        <WidgetTitle
          title="Scanning Peak Hours"
          tooltipContent={
            <>
              Scan volume by day and hour
              <br />
              Find peak usage times
            </>
          }
        />
      </div>
      <LbHorizontalScrollContainer variant="inBox">
        <div className={classes.container}>
          <div className={classes.grid}>
            {matrix && (
              <>
                <HeatmapTitleRow />
                {daysOfWeek.map((day) => (
                  <HeatmapDayRow
                    key={day}
                    day={day}
                    hours={matrix.data[day].hours}
                    maxCount={matrix.maxCount}
                  />
                ))}
              </>
            )}
          </div>
          <HeatmapLegend />
        </div>
      </LbHorizontalScrollContainer>
    </Surface>
  );
});

export { ScanningPeakHoursWidget };
